import { AdventureBox } from '@/Assets/Icons/AdventureBox';
import PlaceholderBg from '../../assets/PlaceholderBg.png';

export function ActiveAdventuresPlaceholder() {
  return (
    <div className="quests-adventures--placeholder">
      <div className="quests-adventures--placeholder-bg">
        <img src={PlaceholderBg} alt="" />
      </div>
      <AdventureBox
        width={63}
        height={63}
        className="quests-adventures--placeholder-icon"
      />
      <div className="quests-adventures--placeholder-heading">
        There are no new adventures available at the moment
      </div>
      <div className="quests-adventures--placeholder-text">
        Check back later for new quests and opportunities to earn extra points
        and multipliers.
      </div>
    </div>
  );
}
